<template>
  <WsRow>
    <WsCol v-for="(item, itemIndex) in numberData" :key="itemIndex" cols="4" smcols="6">
      <DashboardNumberCard
        :value="item.title.value"
        :title="item.title.text"
        :title-icon="item.title.icon"
        :total-number="item.title.num"
        :total-number-tool-tips="item.title.tooltips"
        :updated-at="item.updated_at"
        :bottom-text="item.bottomText"
        :number-infos="item.numberInfos"
        :system-type="item.systemType"
        :big-number="item.bigNumber"
        :isDisable="item.isDisable"
        :disable-icon="item.disableIcon"
        :disable-btn-text="item.disableBtnText"
        :disable-text="item.disableText"
        :isLoading="isLoading"
        :multiSystemClasses="item.multiSystemClasses"
        @number-click="numberClick($event)"
        @btn-click="btnClick(item, itemIndex)"
      />
    </WsCol>
  </WsRow>
</template>
<script>
export default {
  name: 'DashboardNumberCardList',
  props: {
    numberData: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    numberClick($event) {
      this.$emit('number-click', $event);
    },
    btnClick(item, itemIndex) {
      this.$emit('btn-click', { item, itemIndex });
    },
  },
};
</script>
